/**
 * Validates whether a string is a valid image URL or base64 data
 * @param imageUrl The image URL or base64 string to validate
 * @returns boolean indicating if the image data is valid
 */
export const isValidImageData = (imageUrl: string | null): boolean => {
  if (!imageUrl) return false;

  // Check if it's a base64 encoded image
  if (imageUrl.startsWith('data:image')) {
    return true;
  }

  // Check if it's a valid URL
  try {
    new URL(imageUrl);
    return true;
  } catch (e) {
    return false;
  }
};

/**
 * Gets appropriate image source with fallback
 * @param imageUrl The primary image URL or base64 data
 * @param fallbackUrl The fallback image to use if primary is invalid
 * @returns The appropriate image source
 */
export const getImageSrc = (imageUrl: string | null, fallbackUrl: string): string => {
  return isValidImageData(imageUrl) ? (imageUrl as string) : fallbackUrl;
};
